// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/axios';
import { dispatch } from '../index';

// ----------------------------------------------------------------------

const initialState = {
    dailyCollectionList: [],
    totalRows: 0,
    rowsPerPage: 5,
    page: 0,
    message: null,
    status: false,
    error: ''
};

const slice = createSlice({
    name: 'dailyCollectionReport',
    initialState,
    reducers: {
        hasError(state, action) {
            state.error = action.payload;
        },
        setDailyCollections(state, action) {
            state.dailyCollectionList = action.payload;
        },
        setDailyCollectionRowPerPage(state, action) {
            state.rowsPerPage = action.payload;
        },
        setDailyCollectionPage(state, action) {
            state.page = action.payload;
        },
        setTotalRows(state, action) {
            state.totalRows = action.payload;
        }
    }
});

// Reducer
export default slice.reducer;
export const { setDailyCollectionRowPerPage, setDailyCollectionPage } = slice.actions;
// ----------------------------------------------------------------------

export function getDailyCollections(data) {
    return async () => {
        try {
            const response = await axios.post('/reports/daily_collection', data);
            if (response.data.status) {
                dispatch(slice.actions.setDailyCollections(response.data.data));
                dispatch(slice.actions.setTotalRows(response.data.total_rows));
            } else {
                dispatch(slice.actions.hasError(response.data.message));
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error.message));
        }
    };
}
